import React from 'react';
import moment from 'moment';
import _ from 'lodash';
import { Button, Typography } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import { faCalendarAlt, faPlus } from '@fortawesome/pro-light-svg-icons';
import SingleDay from './SingleDay';
import './MultiSingleDayPicker.scss';


/**
 * @param {import('react-bootstrap-daterangepicker').Props & { description: string... }} props
 */
const MultiSingleDayPicker = (props) => {
    const { onApply, onHide, description, multiSingleDates, setMultiSingleDates, isEmpty, format = "MM-DD-YYYY", ...other } = props;
    const locale = {
        format: format,
        daysOfWeek: moment.weekdaysShort(),
        monthNames: moment.months(),
    };
    const handleOnApply = (event, picker) => {
        const updatedMultiSingleDates = multiSingleDates;
        updatedMultiSingleDates.push(picker.startDate);
        setMultiSingleDates(updatedMultiSingleDates)

        onApply(event, picker);
    }

    const onRemoveDate = (x) => {
        const updatedMultiSingleDates = _.cloneDeep(multiSingleDates);
        const index = updatedMultiSingleDates.findIndex(date => date.isSame(x));
        updatedMultiSingleDates.splice(index, 1);
        setMultiSingleDates(updatedMultiSingleDates);
    }

    return (
        <>
            {description ?
                <div className="labelWrapper">
                    <Typography className="label" >{description.slice(0, 55)}</Typography>
                </div>
                : ''}
            <div className={`drpDisplay ${isEmpty && "error"}`}>
                <div className="pull-left">
                    <FontAwesomeIcon className='calendarIcon' icon={faCalendarAlt} />
                </div>
                {multiSingleDates.map(x => (
                    <SingleDay
                        label={x.format('L')}
                        onRemove={() => {
                            onRemoveDate(x)
                        }}
                    />
                ))}
                <DateRangePicker
                    key={'_' + Math.random().toString(36).substr(2, 9)}
                    className='drp'
                    initialSettings={{
                        autoApply: true,
                        applyClass: 'singleDatePicker',
                        alwaysShowCalendars: false,
                        containerClass: 'containerStyles',
                        autoClose: false,
                        isInvalidDate: (x) => multiSingleDates.some(selected => selected.isSame(x)),
                        locale: locale,
                        singleDatePicker: true,
                        ...other,
                    }}
                    onApply={handleOnApply}
                    onHide={onHide}
                >
                    <Button className='calendarIcon'>
                        <FontAwesomeIcon className='calendarIcon' icon={faPlus} />
                    </Button>
                </DateRangePicker>
            </div>
        </>

    )
}

export default (MultiSingleDayPicker);